import { render, staticRenderFns } from "./dialogCom.vue?vue&type=template&id=3bebca2f&scoped=true&"
import script from "./dialogCom.vue?vue&type=script&lang=js&"
export * from "./dialogCom.vue?vue&type=script&lang=js&"
import style0 from "./dialogCom.vue?vue&type=style&index=0&id=3bebca2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bebca2f",
  null
  
)

export default component.exports